module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Mapbox":"Mapbox","Token":"Token"}}')
  delete Component.options._Ctor
}
